/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserTourLeaderStats } from '../../models/user-tour-leader-stats';

export interface IdentityControllerGetMyselfStats$Params {
}

export function identityControllerGetMyselfStats(http: HttpClient, rootUrl: string, params?: IdentityControllerGetMyselfStats$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserTourLeaderStats;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerGetMyselfStats.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserTourLeaderStats;
      }>;
    })
  );
}

identityControllerGetMyselfStats.PATH = '/identity/myself/stats';
